import React from 'react';
import LoginForm from '../features/auth/components/login-form';
import Logo from "@common/components/logo";
import AppButton from "@common/components/app-button";
import {useNavigate} from "react-router-dom";

const LoginPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-[#DFE6E7] flex items-center justify-center p-4">
            <div className="max-w-md w-full">
                <div className="flex flex-col gap-8 bg-white rounded-[2rem] shadow-sm p-8 border border-gray-200">
                    <Logo/>
                    <LoginForm/>
                </div>
                <div className="mt-8 w-full flex justify-center">
                    <AppButton
                        onClick={() => navigate("/register")}
                        className="font-semibold text-base border-2 !border-on-surface h-[40px] rounded-full !px-5 hover:bg-on-surface/5"
                        label="Załóż konto"
                    />
                </div>
            </div>
        </div>
    );
};

export default LoginPage;


